import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { DragonBetLogo } from 'src/domains/layouts/shared/assets/icons/logo/dragonbet.logo';
import { LogoLink } from 'src/domains/layouts/webview/components/HeaderMainLogo.style';
import { DragonBetBrandIcon } from 'src/domains/layouts/shared/assets/icons/brand/DragonBetBrandIcon';
import { DragonBetBrandIconGradient } from 'src/domains/layouts/shared/assets/icons/brand/DragonBetBrandIconGradient';
import { logoBaseCss, styleNavIcon as styleSignUpNavIcon } from 'src/domains/players/webview/components/Account/accountPanel/accountNavigation/signUpLinkNav/SignUpIcons.style';
import { iconFillQuickHeader } from 'src/domains/layouts/webview/modules/layoutSkeleton/Header/quickHeader/SignUpIcons.style';
import { styleNavIcon as styleNotificationNavIcon } from 'src/domains/players/webview/components/Account/traderChat/components/NotificationIcons.style';
import { DragonBetDarkLogo } from 'src/domains/layouts/shared/assets/icons/logo/dragonbetDark.logo';
import { css, SerializedStyles } from '@emotion/react';

export const DragonBetMainHeaderLogo = withConfig(theme => styled(DragonBetLogo, { label: 'DragonBetMainHeaderLogo' })`
    height: 24px;
    width: 108px;
    @media ${theme.star.mediaQuery.largeDesktop} {
        height: 36px;
        width: 171px;
    }
`);
export const CompliancePopupLogo = withConfig(theme => styled(DragonBetDarkLogo, { label: 'CompliancePopupLogo' })`
    width: 228px;
    @media ${theme.star.mediaQuery.tablet} {
        width: 262px;
    }
`);

export const DragonBetMainHeaderLink = withConfig(theme => styled(LogoLink, { label: 'DragonBetMainHeaderLink' })`
    position: relative;
    left: 8px;
    top: 2px;
    @media ${theme.star.mediaQuery.largeDesktop} {
        top: 0;
        left: 0;
    }
`);

export const DragonBetSignUpLogo = styled(DragonBetLogo, { label: 'DragonBetSignUpLogo' })`
    ${logoBaseCss()};
    fill: #fff;
    width: 182px;
`;

export const DragonBetIconWrapper = styled(DragonBetBrandIcon, { label: 'DragonBetIconWrapper' })`
    ${styleSignUpNavIcon()};
`;

export const LogoDragonBetQuickHeader = styled(DragonBetBrandIconGradient, { label: 'LogoDragonBetQuickHeader' })`
    ${iconFillQuickHeader()};
`;

export const DragonBetBrandTraderChatIconWrapper = withConfig(theme => styled(DragonBetBrandIcon, { label: 'DragonBetBrandTraderChatIconWrapper' })`
    ${styleNotificationNavIcon(theme)};
`);

export const BetReceiptLogo = styled(DragonBetLogo, { label: 'BetReceiptLogo' })`
    height: 24px;
    width: 98px;
`;

export const dragonbetOptimoveBadgeStyle = (): SerializedStyles => css`
    /* BRD section 5: DragonBet Web Inbox styling via Optimove CSS custom properties. */
    /* stylelint-disable custom-property-pattern, custom-property-empty-line-before */
    :root {
        --optimove_inbox_font_family: 'Inter', 'Helvetica Neue', sans-serif;
        --optimove_inbox_width: 380px;
        --optimove_inbox_height: 520px;
        --optimove_inbox_vertical_align: end;
        --optimove_inbox_margin_bottom: 80px;
        --optimove_inbox_margin_horizontal: 24px;
        --optimove_inbox_padding: 8px;
        --optimove_inbox_padding_top: 12px;
        --optimove_inbox_background_color: #1a1a2e;

        --optimove_inbox_header_background_color: #c0392b;
        --optimove_inbox_header_text_color: #fff;
        --optimove_inbox_header_text_font_size: 16px;
        --optimove_inbox_header_font_weight: 700;
        --optimove_inbox_header_bell_background: #a93226;
        --optimove_inbox_header_bell_fill: #fff;
        --optimove_inbox_header_close_button_fill: #fff;
        --optimove_inbox_header_close_button_background: transparent;

        --optimove_inbox_message_background_unread: #2c1e1e;
        --optimove_inbox_message_background_read: #1e1e2c;
        --optimove_inbox_message_border_radius: 8px;
        --optimove_inbox_message_images_border_radius: 8px;
        --optimove_inbox_message_images_small_border_radius: 4px;
        --optimove_inbox_message_images_small_width: 72px;
        --optimove_inbox_message_images_small_height: 72px;
        --optimove_inbox_message_bottom_margin: 8px;

        --optimove_inbox_message_title_font_size: 15px;
        --optimove_inbox_message_title_font_weight: 700;
        --optimove_inbox_message_title_font_color: #e8e8e8;
        --optimove_inbox_message_title_padding_bottom: 6px;
        --optimove_inbox_message_content_font_size: 13px;
        --optimove_inbox_message_font_weight: 400;
        --optimove_inbox_message_font_color: #b0b0c8;
        --optimove_inbox_message_default_media_color: #c0392b;

        --optimove_inbox_message_action_button_color: #c0392b;
        --optimove_inbox_message_action_button_background_color: transparent;
        --optimove_inbox_action_menu_background_color: #2c1e1e;
        --optimove_inbox_action_menu_color: #e8e8e8;
        --optimove_inbox_action_menu_hover_color: #e74c3c;
        --optimove_inbox_action_menu_hover_scale: scale(1.05);
        --optimove_inbox_action_menu_hover_transition: 200ms;
        --optimove_inbox_action_menu_font_size: 14px;
        --optimove_inbox_action_menu_icon_size: 18px;
        --optimove_inbox_action_menu_icon_padding: 8px;

        --optimove_inbox_badge_background_color: #c0392b;
        --optimove_inbox_badge_bell_color: #fff;
        --optimove_inbox_badge_border_radius: 50%;
        --optimove_inbox_badge_border: 2px solid #e74c3c;
        --optimove_inbox_badge_width: 56px;
        --optimove_inbox_badge_height: 56px;
        --optimove_inbox_badge_alert_background_color: #e74c3c;
        --optimove_inbox_badge_alert_font_color: #fff;
        --optimove_inbox_badge_alert_border_radius: 50%;
        --optimove_inbox_badge_alert_width: 20px;
        --optimove_inbox_badge_alert_height: 20px;

        --optimove_inbox_badge_position: static;
        --optimove_inbox_badge_top: auto;
        --optimove_inbox_badge_right: auto;
        --optimove_inbox_badge_bottom: auto;
        --optimove_inbox_badge_left: auto;
    }
    /* stylelint-enable custom-property-pattern, custom-property-empty-line-before */
`;

interface DragonBetOptimoveBadgeHostPropsType {
    mobileTopOffset: number;
}

export const DragonBetOptimoveBadgeHost = withConfig(theme => styled('div', { label: 'DragonBetOptimoveBadgeHost' })<DragonBetOptimoveBadgeHostPropsType>`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 52px;
    overflow: visible;
    position: fixed;
    right: 12px;
    top: ${({ mobileTopOffset }): string => `${mobileTopOffset}px`};
    bottom: 0;
    z-index: ${theme.star.zIndexGlobal.rhsMenu + 1};

    @media ${theme.star.mediaQuery.desktop} {
        bottom: 20px;
        height: 52px;
        justify-content: center;
        right: 20px;
        top: auto;
    }
`);
